module.exports = __webpack_public_path__ + "img/skolkovo.84272074.png";